import { render, staticRenderFns } from "./ImprestDocument.vue?vue&type=template&id=55fa8050&scoped=true"
import script from "./ImprestDocument.vue?vue&type=script&lang=js"
export * from "./ImprestDocument.vue?vue&type=script&lang=js"
import style0 from "./ImprestDocument.vue?vue&type=style&index=0&id=55fa8050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fa8050",
  null
  
)

export default component.exports